import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {} from "assets/jss/material-dashboard-react.js";
import { connect } from "react-redux";
import Actions from "redux/actions";
import api from "axios.js";
import { withRouter } from "react-router";
import MaterialTable from "components/MaterialTable.js";
import Button from "components/CustomButtons/Button.js";
import PubSub from "pubsub-js";
import { missionColumns } from "utils/columns";
import axios from "axios";

class FormList extends React.Component {
  constructor(props) {
    super(props);
    this.actionsCache = null;
    this.actionsCacheKey = null;
    this.cancelSources = new Set();
    this._isMounted = false;
    this.state = { tableLoading: false };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.cancelAllRequests("MissionsList unmounted");
    this.actionsCache = null;
    this.actionsCacheKey = null;
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  getActions = () => {
    if (this.actionsCache && this.actionsCacheKey === this.props.canDelete) {
      return this.actionsCache;
    }
    const { canDelete } = this.props;
    const actions = [
      {
        icon: "edit",
        tooltip: "Modifier la mission",
        onClick: (event, rowData) =>
          this.props.history.push(`/missions/${rowData.id}/edit`),
      },
      {
        icon: "remove_red_eye",
        tooltip: "Voir les details de la mission",
        onClick: (event, rowData) =>
          this.props.history.push(`/missions/${rowData.id}`),
      },
      canDelete && {
        icon: "delete",
        tooltip: "Supprimer la mission",
        onClick: (event, rowData) =>
          PubSub.confirm({
            title: "Supprimer l'element ?",
            subtitle: "Cette action est irreversible.",
            onAgree: (_) =>
              this.props.dispatch(Actions.deleteMission(rowData.id)),
          }),
      },
      {
        icon: (p) => <Button color="primary">Nouvelle Mission</Button>,
        isFreeAction: true,
        onClick: (event) => this.props.history.push(`/missions/new`),
      },
    ].filter(Boolean);
    this.actionsCache = actions;
    this.actionsCacheKey = canDelete;
    return this.actionsCache;
  };

  render() {
    const c = this.props.classes;
    return (
      <div className={c.container}>
        <MaterialTable
          title=""
          isLoading={this.state.tableLoading}
          columns={missionColumns}
          actions={this.getActions()}
          data={(query) => {
            const requestedPage = query?.page || 0;
            const requestedPageSize = query?.pageSize || 20;
            const search = query?.search?.trim();
            const orderBy = query?.orderBy?.field;
            const orderDirection = query?.orderDirection;
            const filters =
              Array.isArray(query?.filters) && query.filters.length
                ? query.filters
                    .filter((f) => f?.value)
                    .map((f) => ({ field: f?.column?.field, value: f.value }))
                : undefined;
            const source = this.createCancelSource();
            this.updateState({ tableLoading: true });
            const params = {
              page: requestedPage + 1,
              pageSize: requestedPageSize,
              search: search || undefined,
              orderBy: orderBy || undefined,
              orderDirection: orderDirection || undefined,
              filters: filters ? JSON.stringify(filters) : undefined,
            };
            return api
              .get("/Mission/listLite", { params, cancelToken: source.token })
              .then(({ data }) => {
                const raw = Array.isArray(data?.data)
                  ? data.data
                  : Array.isArray(data)
                  ? data
                  : [];
                const payload = raw.map((m) => ({
                  ...m,
                  Clients: Array.isArray(m.Clients) ? m.Clients : [],
                  Appartements: Array.isArray(m.Appartements)
                    ? m.Appartements
                    : [],
                  Accomptes: Array.isArray(m.Accomptes) ? m.Accomptes : [],
                  nbAppart:
                    typeof m.nbAppart === "number"
                      ? m.nbAppart
                      : Array.isArray(m.Appartements)
                      ? m.Appartements.length
                      : 0,
                }));
                const totalCount =
                  typeof data?.total === "number"
                    ? data.total
                    : typeof data?.totalCount === "number"
                    ? data.totalCount
                    : payload.length;
                this.updateState({ tableLoading: false });
                return { data: payload, page: requestedPage, totalCount };
              })
              .catch((error) => {
                if (axios.isCancel(error)) return { data: [], page: requestedPage, totalCount: 0 };
                this.updateState({ tableLoading: false });
                PubSub.notif({
                  txt: "Impossible de charger les missions.",
                  color: "danger",
                });
                return { data: [], page: requestedPage, totalCount: 0 };
              })
              .finally(() => this.releaseCancelSource(source));
          }}
          onRowClick={(event, rowData) =>
            this.props.history.push(`/missions/${rowData.id}`)
          }
          options={{
            filtering: true,
            pageSize: 20,
            actionsColumnIndex: -1,
          }}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {},
});

const mapStateToProps = (state) => ({
  missions: state.reducer.missions,
  canDelete: state.reducer.canDelete,
});
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormList))
);
